// src/pages/gas/GASMissedAppointment.jsx
import React from "react";

const dummyMissed = [
  {
    id: "MISS-001",
    agenda: "Investor Meeting",
    scheduledTime: "10:00 AM",
    reason: "No Show",
  },
  {
    id: "MISS-002",
    agenda: "Client Review",
    scheduledTime: "03:30 PM",
    reason: "Delayed beyond threshold",
  },
];

const GASMissedAppointment = () => {
  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h1 className="text-xl font-semibold mb-4">Missed Appointments</h1>

      {dummyMissed.map((item) => (
        <div
          key={item.id}
          className="border border-red-700 rounded-xl p-4 mb-4"
        >
          <h2 className="font-semibold">{item.agenda}</h2>
          <p className="text-sm text-gray-400">
            Scheduled: {item.scheduledTime}
          </p>
          <p className="text-sm text-red-400">
            Reason: {item.reason}
          </p>

          <button className="mt-3 text-xs px-3 py-1 border border-cyan-600 rounded">
            Re-initiate Appointment
          </button>
        </div>
      ))}

      {dummyMissed.length === 0 && (
        <p className="text-sm text-gray-500">
          No missed appointments 🎉
        </p>
      )}
    </div>
  );
};

export default GASMissedAppointment;
